export default __webpack_public_path__ + "static/media/logo_immutable.8e826349.jpeg";